import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { Card, Text } from 'components/Library'
import { colors } from 'components/Library/theme'
import { useSelector } from 'react-redux'

import dayjs from 'dayjs'
import { CANTIDAD_MESES_GRAFICO } from 'utils/constants'

const TotalPages = () => {
  const { paginas } = useSelector((state) => state.pages)
  const [datosGrafico, setDatosGrafico] = useState([])

  useEffect(() => {
    const fechaTemporal = new Date()
    const ultimosMeses = []

    for (let i = 0; i < CANTIDAD_MESES_GRAFICO; i++) {
      const mes = dayjs(fechaTemporal).format('MMM')
      const anio = dayjs(fechaTemporal).format('YYYY')

      ultimosMeses.unshift({ mes: `${mes} ${anio}`, valor: 0 })
      fechaTemporal.setMonth(fechaTemporal.getMonth() - 1)
    }

    const datos = paginas.reduce((acc, curr) => {
      const fecha = dayjs(curr.fechaCreacion).format('MMM YYYY')

      const index = ultimosMeses.findIndex((item) => item.mes === fecha)
      if (index !== -1) acc[index].valor++

      return acc
    }, ultimosMeses)

    setDatosGrafico(datos)
  }, [paginas])

  return (
    <Card style={{ width: '100%' }}>
      <div
        style={{
          padding: '2rem 2rem 0 2rem'
        }}
      >
        <Text color={colors.primary} size="extralarge" weight="bold">
          {paginas.length}
        </Text>
        <Text size="large" color={colors.primary}>
          Páginas totales
        </Text>
      </div>
      <Chart
        options={{
          chart: {
            toolbar: {
              show: false
            }
          },
          colors: [colors.primary],
          xaxis: {
            labels: {
              show: false
            },
            axisTicks: {
              show: false
            },
            categories: datosGrafico.map((item) => item.mes)
          },
          yaxis: {
            show: false
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            y: {
              formatter: parseInt
            }
          },
          grid: {
            show: false,
            padding: {
              top: 0,
              right: 0,
              bottom: -15,
              left: 0
            }
          }
        }}
        series={[
          {
            name: 'Paginas creadas',
            data: datosGrafico.map((item) => item.valor)
          }
        ]}
        height={100}
        type="area"
        toolbar={{
          show: false
        }}
      />
    </Card>
  )
}

export default TotalPages

// dateRanges: [
//   {
//     startDate: dayjs(fechaInicio).format("YYYY-MM-DD"),
//     endDate: "today",
//   },
// ],
// dimensions: [
//   {
//     name: "customEvent:idioma",
//   },
//   {
//     name: "customEvent:modo_edicion",
//   },
//   {
//     name: "city",
//   },
//   {
//     name: "month",
//   },
//   {
//     name: "customEvent:tipo_cta",
//   },
// ],
// metrics: [
//   {
//     name: "sessions",
//   },
//   {
//     name: "activeUsers",
//   },
//   {
//     name: "averageSessionDuration",
//   },
//   // {
//   //   name: "activeUsers",
//   // },
// ],
